import { SearchAdminInvoiceReportsCsvEncode } from '@/context/services/admin_invoice_reports/AdminInvoiceReportExport.service';
import { useTranslation } from '@/i18n';
import type { ActionMenuItems } from '@moneyforward/ap-frontend-components';
import { useMemo } from 'react';
import { MenuItem } from './MenuItem';

type ItemArgs = {
  onExport: (type: SearchAdminInvoiceReportsCsvEncode) => () => void;
};

export const useItems = ({ onExport }: ItemArgs): ActionMenuItems => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        key: '1',
        label: (
          <MenuItem
            label={t('admin_invoice_reports.export.utf-8.label')}
            tooltip={t('admin_invoice_reports.export.utf-8.tooltip')}
          />
        ),
        onClick: onExport(SearchAdminInvoiceReportsCsvEncode['utf-8']),
      },
      {
        key: '2',
        label: (
          <MenuItem
            label={t('admin_invoice_reports.export.shift-jis.label')}
            tooltip={t('admin_invoice_reports.export.shift-jis.tooltip')}
          />
        ),
        onClick: onExport(SearchAdminInvoiceReportsCsvEncode['shift_jis']),
      },
    ],
    [onExport, t]
  );
};
